const RESOURCE_NAME = '/reports-schedulers';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});